<template>
  <div class="menu-box">
    <a-menu class="hm-menu-h5" mode="inline" :open-keys="openKeys" :getPopupContainer="triggerNode => triggerNode.parentNode" @openChange="onOpenChange">
      <a-sub-menu v-for="item in menuList" :key="item.key">
        <span slot="title">
          <div class="menu-submenu-title" @click="selectParentMenu(item)">{{ item.title }}</div>
        </span>
        <a-col :span="['domestic-consulting-services'].includes(subItem.key) ? 12 : 8" v-for="subItem in item.children" :key="subItem.key" class="menu-item" @click="selectMenu(subItem)">
          <a-menu-item>{{ subItem.label }}</a-menu-item>
        </a-col>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<script>
export default {
  name: 'hmMenuH5',
  data () {
    return {
      rootSubmenuKeys: ['1', '2', '4', '5', '6', '7', '8', '9', '10', '11'],
      openKeys: ['1', '2', '4', '5', '6', '7', '8', '9', '10', '11'],
      commonMenuList: [
        {
          key: '1',
          title: '产品介绍-税纪云',
          path: '/zh/contact',
          children: [
            // { key: 'newTaxera', label: '税纪云', path: '/product/newTaxera' },
            // { key: 'taxcellent', label: 'Taxcellent', path: '/product/taxcellent' },
            { key: 'autoDeclare', label: '全税种', path: '/product-service/details?key=autoDeclare' },
            { key: 'digitalPlatform', label: '数电票', path: '/product-service/details?key=digitalPlatform' },
            { key: 'etrPlatform', label: '出口退税', path: '/product-service/details?key=etrPlatform' },
            { key: 'citPlatform', label: '企业所得税', path: '/product-service/details?key=citPlatform' },
            { key: 'rddExpenseTax', label: '研发加计', path: '/rddExpenseTax' },
            { key: 'iitPlatform', label: '个人所得税', path: '/product-service/details?key=iitPlatform' },
            { key: 'riskManagement', label: '风险管理', path: '/riskManagement' },
            { key: 'withoutPlatform', label: '非贸付汇', path: '/product-service/details?key=withoutPlatform' },
            { key: 'dec', label: '一键申报', path: '/product/dec' }
            // { key: 'chataxera', label: '金税一言', path: '/product/chataxera' },
            // { key: 'lawLibrary', label: '法规库', path: '/product/lawLibrary' }
            // { key: 'fincellent', label: '财纪云', path: '/product/fincellent' },
            // { key: 'ibd', label: '行业数据库', path: '/product/ibd' }
            // { key: 'ftc', label: '财税专聘', path: '/product/ftc' }
          ]
        },
        {
          key: '10',
          title: '产品介绍-Taxcellent',
          path: '/zh/contact',
          children: [
            { key: 'taxcellent', label: 'Taxcellent', path: '/product-service/details?key=taxcellentOversea' },
            { key: 'taxcellentTp', label: '全球关联交易', path: '/product-service/details?key=taxcellentTp' },
            { key: 'taxcellentGlobal', label: '海外财税咨询', path: '/product-service/details?key=taxcellentGlobal' }
          ]
        },
        {
          key: '11',
          title: '产品介绍-AI Agent',
          path: '/zh/contact',
          children: [
            { key: 'chataxera', label: '金税一言', path: '/product/chataxera' },
            { key: 'chartTexeraJc', label: '精财一言', path: '' },
            { key: 'lawLibrary', label: '法规库', path: '/product/lawLibrary' }
          ]
        },
        {
          key: '2',
          title: '咨询服务',
          path: '',
          children: [
            // { key: 'product-tax-consulting', label: '税务咨询', path: '/service/product-tax-consulting' },
            // { key: 'product-outsourcing-services', label: '外包服务', path: '/service/product-outsourcing-services' },
            // { key: 'product-global-platform', label: '国际服务', path: '/international' }
            { key: 'domestic-consulting-services', label: '国内常年税务顾问服务', path: '' },
            { key: 'international-tax-services', label: '国际财税服务', url: 'https://newtaxera-v3.huamengtech.com/japi3/epp/admin/link?source=HmWebsite&targetUrl=https://airtaxglobal.com/' }
          ]
        },
        // {
        //   key: '9',
        //   title: '解决方案',
        //   path: '',
        //   children: [
        //     { key: 'solution-chain-retail', label: '连锁零售', path: '/solution-chain-retail' }
        //   ]
        // },
        // &:nth-child(4)样式控制第四个不展示箭头
        {
          key: '3',
          title: '行业案例',
          path: '/case'
          // children: [
          //   // { key: 'case', label: '案例介绍', path: '/case' }
          //   { key: '1', label: '妍丽', path: '/case/details?key=01' },
          //   { key: '2', label: '名创优品', path: '/case/details?key=02' },
          //   { key: '3', label: '瑞派宠物', path: '/case/details?key=03' },
          //   { key: '4', label: '英孚教育', path: '/case/details?key=04' },
          //   { key: '6', label: '互联网货运', path: '/case/details?key=06' },
          //   { key: '7', label: '建筑用工', path: '/case/details?key=07' },
          //   { key: '8', label: '国家能源', path: '/case/details?key=08' },
          //   { key: '9', label: '吉田拉链', path: '/case/details?key=09' }
          // ]
        },
        // {
        //   key: '3',
        //   title: '行业案例',
        //   path: '/zh/contact',
        //   children: [
        //     { key: '1', label: '制造业', path: '' },
        //     { key: '2', label: '消费零售', path: '' },
        //     { key: '3', label: '互联网平台', path: '' },
        //     { key: '4', label: '物流运输', path: '' },
        //     { key: '5', label: '能源综合', path: '' },
        //     { key: '6', label: '金融行业', path: '' },
        //     { key: '7', label: '地产行业', path: '' },
        //     { key: '8', label: '跨境电商', path: '' }
        //   ]
        // },
        {
          key: '7',
          title: '产品视频',
          path: '',
          children: [
            { key: 'video-product', label: '产品介绍', path: '' },
            { key: 'video-helper', label: 'AI小助手', path: '' },
            { key: 'video-shop', label: '华为云商城', path: '' },
            { key: 'GROUP_MANAGEMENT', label: '集团管理' },
            { key: 'CHATAXERA', label: '金税一言' },
            { key: 'IIT', label: '个人所得税' },
            { key: 'HKTAX', label: '香港利得税' },
            { key: 'TP', label: '转让定价' },
            { key: 'EXPORT_REBATES', label: '出口退税' },
            { key: 'FINAL_SETTLEMENT', label: '汇算清缴' },
            { key: 'NON_TRADE', label: '非贸付汇' },
            { key: 'RDTC', label: '研发加计' },
            { key: 'ELECT_INVOICE', label: '数电票' },
            { key: 'RETAIL_INDUSTRY', label: '零售行业' }
          ]
        },
        {
          key: '4',
          title: '新闻中心',
          path: '',
          children: [
            { key: 'news-advertisement', label: '研讨活动', path: '/news-advertisement' },
            { key: 'news-center', label: '新闻动态', path: '/news-center' }
          ]
        },
        {
          key: '5',
          title: '财税沙龙',
          path: '',
          children: [
            { key: '1', label: '互动论坛', path: 'salon-tax' },
            { key: '2', label: '智慧税务', path: 'salon-tax' },
            { key: '3', label: '行业观点', path: 'salon-tax' },
            { key: '4', label: '政策热点', path: 'salon-tax' }
          ]
        },
        {
          key: '6',
          title: '关于华盟',
          path: '',
          children: [
            { key: '1', label: '华盟介绍', path: '/introduce' },
            { key: '2', label: '华盟招聘', path: '/invite-job' },
            { key: '3', label: '华盟风采', path: '/hm-style' },
            { key: '4', label: '联系我们', path: '/about' }
            // {
            //   key: '3',
            //   label: '加入我们',
            //   path: '/product/ftc'
            // }
          ]
        }
        // {
        //   key: '8',
        //   title: '招聘',
        //   path: '',
        //   children: [
        //     { key: '1', label: '华盟招聘', path: '/invite-job' },
        //     { key: '2', label: '华盟风采', path: '/hm-style' }
        //   ]
        // }
      ],
      inviteJobMenu: [
        {
          key: '1',
          title: '招聘',
          path: '',
          children: [
            { key: '1', label: '社会招聘', path: '/social-recruitment' },
            { key: '2', label: '校园招聘', path: '/campus-recruitment' },
            { key: '3', label: '华盟风采', path: '/hm-style' }
          ]
        },
        {
          key: '2',
          title: '关于华盟',
          path: '',
          children: [
            { key: '1', label: '华盟介绍', path: '/introduce' },
            { key: '2', label: '联系我们', path: '/about' }
          ]
        }
      ]
    }
  },
  computed: {
    menuList () {
      return this.$route.name === 'social-recruitment' || this.$route.name === 'campus-recruitment' || this.$route.name === 'social-recruitment-detail' ? this.inviteJobMenu : this.commonMenuList
    }
  },
  methods: {
    onOpenChange (openKeys) {
      console.log('%copenKeys', 'background-color: green;color: #fff;', openKeys)
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    selectMenu (record = {}) {
      console.log('%cselectMenuselectMenu', 'background-color: green;color: #fff;', record)
      const { key, path, url } = record
      if (['video-product', 'video-shop', 'video-helper'].includes(key)) {
        this.$bus.$emit('onShowVideo', key)
        return
      } else if (['GROUP_MANAGEMENT', 'EXPORT_REBATES', 'CHATAXERA', 'FINAL_SETTLEMENT', 'RDTC', 'IIT', 'NON_TRADE', 'HKTAX', 'ELECT_INVOICE', 'TP', 'RETAIL_INDUSTRY'].includes(key)) {
        this.$bus.$emit('onShowVideo', 'AI', key)
        return
      }
      if (path) this.$router.push(path)
      if (url) window.open(url)
      this.$emit('menuChange')
    },
    selectParentMenu (item) {
      const { path } = item
      if (!item.children) {
        this.$router.push(path)
        this.$emit('menuChange')
      }
    }
  }
}
</script>

<style lang="less">
.menu-box{
  overflow-y: auto;
  padding-bottom: 120px;
  -webkit-overflow-scrolling: touch;
  .hm-menu-h5 {
    .ant-menu-sub.ant-menu-inline {
      background-color: #F5F9FF;
    }
    .menu-item {
      height: 4.8rem;
      line-height: 4.8rem;
      text-align: left;
      font-size: 1.4rem;
      color: #292F3A;
      padding-left: 2rem;
    }
    .ant-menu-submenu-title {
      font-size: 1.6rem !important;
      color: #848D9E;
      font-weight: 500 !important;
      height: 4.4rem !important;
      line-height: 4.4rem !important;
      padding-left: 2rem !important;
    }
    .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover {
      color: #3E77FF;
    }
    .ant-menu-submenu{
      &:nth-child(5){
        .ant-menu-submenu-title{
          .ant-menu-submenu-arrow{
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hm-menu/index_h5.vue